"use strict";

/**
  * @reach/skip-nav v0.18.0
  *
  * Copyright (c) 2018-2022, React Training LLC
  *
  * This source code is licensed under the MIT license found in the
  * LICENSE.md file in the root directory of this source tree.
  *
  * @license MIT
  */

// src/reach-skip-nav.tsx
import * as React from "react";
var defaultId = "reach-skip-nav";
var SkipNavLink = React.forwardRef(function SkipNavLink2(_ref, forwardedRef) {
  let {
    as: Comp = "a",
    children = "Skip to content",
    contentId,
    ...props
  } = _ref;
  let id = contentId || defaultId;
  return /* @__PURE__ */React.createElement(Comp, {
    ...props,
    ref: forwardedRef,
    href: "#".concat(id),
    "data-reach-skip-link": "",
    "data-reach-skip-nav-link": ""
  }, children);
});
SkipNavLink.displayName = "SkipNavLink";
var SkipNavContent = React.forwardRef(function SkipNavContent2(_ref2, forwardedRef) {
  let {
    as: Comp = "div",
    id: idProp,
    ...props
  } = _ref2;
  let id = idProp || defaultId;
  return /* @__PURE__ */React.createElement(Comp, {
    ...props,
    ref: forwardedRef,
    id,
    "data-reach-skip-nav-content": ""
  });
});
SkipNavContent.displayName = "SkipNavContent";
export { SkipNavContent, SkipNavLink };